import { render } from "./Privacy.vue?vue&type=template&id=0cfd6000&scoped=true"
const script = {}

import "./Privacy.vue?vue&type=style&index=0&id=0cfd6000&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cfd6000"]])

export default __exports__